// extracted by mini-css-extract-plugin
module.exports = {"counterBtn":"GroupedButtons_counterBtn__3XNSI","minBtn":"GroupedButtons_minBtn__3gnuR","addBtn":"GroupedButtons_addBtn__3wC_d"};